module.exports = __webpack_public_path__ + "img/charisma.f273522.jpg";